export default __webpack_public_path__ + "static/media/blog-img.81191810.jpg";